import React from "react";

import { Typography } from "@mui/material";
import { symbols } from "root/utils";

import TooltipIcon from "root/components/Tooltip/TooltipIcon";

import { numberWithSpaces } from "root/js/utils";

const DefaultCell = ({
  value,
  postfix,
  round = 0,
  fontWeight = 800,
  empty = symbols.none,
  hideZero,
}) => {
  const isInvalid = (hideZero && !+value) || value === null || value === undefined || isNaN(value);

  let displayValue;
  if (isInvalid) {
    displayValue = empty;
  } else if (value < 0) {
    displayValue = `0 ${postfix}`;
  } else {
    displayValue = `${numberWithSpaces(value, round)} ${postfix}`;
  }

  return (
    <Typography
      sx={{
        fontSize: isInvalid ? 13 : 14,
        color: isInvalid ? "#798097" : "inherit",
        fontWeight: isInvalid ? 500 : fontWeight,
      }}>
      {displayValue}
    </Typography>
  );
};

export default DefaultCell;
